import React from 'react';
import {observable} from "mobx";

// the hook
import { useTranslation } from 'react-i18next';

class Store {
  @observable isLogin = false;
  @observable searchKeyword = null;
  @observable shoppingTotal = 0;
  @observable userInfo = null;
}

export default new Store()
